/**
 * Anbieterunabhängiger Vertrag für Metarr-Code-Arbeitspakete.
 *
 * Das Modell liefert ausschließlich begrenzte Textänderungen. GitLab-Zugriff,
 * Pfadprüfung, Größenmessung und Veröffentlichung bleiben beim Cubic-Server.
 */
/**
 * Der Zielbranch, solange ein Projekt keinen eigenen gepflegt hat.
 *
 * Er war bis zum 23.08.2026 instanzweit fest verdrahtet. Das stimmte für
 * cubic studio und für nichts sonst: `cubicmeta/cubic-time` nennt seinen
 * Hauptzweig `develop`, weshalb dort jeder Start mit „404 Branch Not Found"
 * endete, bevor überhaupt ein Modell lief. Der Wert bleibt als Rückfallebene
 * für Projekte, die das Feld noch nicht gesetzt haben.
 */
export const STANDARD_ZIEL_BRANCH = "development";
/**
 * Ist der Name als Git-Zweig überhaupt zulässig?
 *
 * Reine Formprüfung ohne Rollenurteil — der Zielbranch ist ein geschützter
 * Zweig und würde an `istSichererMetarrCodeBranch` scheitern, das genau ihn
 * ausschließt. Beide brauchen dieselbe Formprüfung, aber verschiedene
 * Antworten auf „darf hier hinein geschrieben werden".
 */
export function istGueltigerBranchName(nameRoh) {
    const name = nameRoh.trim();
    const teile = name.split("/");
    return (name.length >= 1 &&
        name.length <= 255 &&
        name !== "@" &&
        !name.startsWith("-") &&
        !name.startsWith("/") &&
        !name.endsWith("/") &&
        !teile.some((teil) => !teil ||
            teil.startsWith(".") ||
            teil.endsWith(".") ||
            teil.endsWith(".lock")) &&
        !name.includes("..") &&
        !name.includes("@{") &&
        !/[\s~^:?*[\\\]]/.test(name));
}
export const METARR_CODE_ARBEITSPAKET_BUDGETS = [500, 1_000];
export const METARR_CODE_ARBEITSPAKET_ZUSTAENDE = [
    "wartet_planung",
    "plant",
    "bestaetigung_offen",
    "veroeffentlichung_wartet",
    "commit_erstellt",
    "veroeffentlicht",
    "fertig_ohne_mr",
    "abgelehnt",
    "abgebrochen",
    "veroeffentlichung_gescheitert",
    "zu_gross",
    "konflikt",
    "gescheitert",
];
export function zaehleMetarrCodeTextzeilen(text) {
    if (text.length === 0)
        return 0;
    return text.split(/\r?\n/).length;
}
export function zaehleMetarrCodeErsetzung(er) {
    return {
        hinzugefuegt: zaehleMetarrCodeTextzeilen(er.nachher),
        entfernt: zaehleMetarrCodeTextzeilen(er.vorher),
    };
}
export function metarrCodeArbeitspaketUmfang(dateien) {
    const hinzugefuegt = dateien.reduce((summe, datei) => summe + datei.hinzugefuegteZeilen, 0);
    const entfernt = dateien.reduce((summe, datei) => summe + datei.entfernteZeilen, 0);
    return { hinzugefuegt, entfernt, gesamt: hinzugefuegt + entfernt };
}
//# sourceMappingURL=metarr-code-arbeitspaket.js.map